import { Badge } from '@chakra-ui/react';
import { StudentRecentPaceStatus } from '@duke-hq/svc-api-db';

export interface FourteenDayPaceBadgeLabels {
  great: string;
  good: string;
  slow: string;
  none: string;
  na: string;
}

const defaultLabels: FourteenDayPaceBadgeLabels = {
  great: 'Great',
  good: 'Good',
  slow: 'Slow',
  none: 'None',
  na: 'N/A',
};

interface FourteenDayPaceBadgeProps {
  pace: StudentRecentPaceStatus | null;
  labels?: Partial<FourteenDayPaceBadgeLabels>;
}

function getFourteenDayPaceMetadata(pace: StudentRecentPaceStatus, l: FourteenDayPaceBadgeLabels) {
  const metadata: Record<StudentRecentPaceStatus, { label: string; color: string }> = {
    GREAT: { label: l.great, color: 'blue' },
    GOOD: { label: l.good, color: 'green' },
    SLOW: { label: l.slow, color: 'orange' },
    NONE: { label: l.none, color: 'red' },
  } as const;

  return metadata[pace] ?? { label: l.na, color: 'gray' };
}

export function FourteenDayPaceBadge({
  pace,
  labels,
}: FourteenDayPaceBadgeProps): React.ReactElement | null {
  const l = { ...defaultLabels, ...labels };

  if (pace === null) {
    return null;
  }

  const { label, color } = getFourteenDayPaceMetadata(pace, l);

  return (
    <Badge
      fontSize="xs"
      fontWeight="bold"
      borderRadius="full"
      variant="solid"
      colorScheme={color}
      textTransform="none"
    >
      {label}
    </Badge>
  );
}
